import React from 'react'
import { getLocationDisplay, getDateDisplay } from './dashboard-utils'
import styles from './LeadDashboardPage.module.css'

const agentCalendlyLinks = {
  'jazmin@roaminghunger.com': 'https://meetings.hubspot.com/jazmin24',
  'george@roaminghunger.com': 'https://meetings.hubspot.com/george605/15',
  'katrina@roaminghunger.com': 'https://meetings.hubspot.com/katrina-chavez/katrinas-15-minute-catering-meeting',
  'sydney@roaminghunger.com': 'https://meetings.hubspot.com/sydney120/sydneys-15-minute-catering-meeting',
  'josh@roaminghunger.com': 'https://meetings.hubspot.com/joshua500/joshs-15-minute-catering-meeting',
  'jody@roaminghunger.com': 'https://meetings.hubspot.com/jody-murphy/jodys-15-minute-meeting',
  'nina@roaminghunger.com': 'https://meetings.hubspot.com/nscafidi/ninas-15-minute-meeting-link',
}
export default function BookACallSection(props) {
  const { lead } = props 
  const experience_manager = lead.experience_manager
  return experience_manager && (
    <div className={[styles.card]}>
      <div className='flex mb-4'>
        { experience_manager.photo && (
          <div className='border border-gray-400 rounded-full overflow-hidden mr-4'>
            <img 
              className='bg-cover h-0 bg-center'
              style={{
                width: '60px',
                paddingTop:'100%', 
                backgroundImage: `url(${experience_manager.photo.url})`
              }} 
              alt='caterer logo' 
            />
          </div>
        )}
        

        <div className='flex flex-1 flex-col justify-center leading-tight'>
          <p className='text-lg text-blue font-bold'>{experience_manager.full_name || 'Munchie Murphy'}</p>
          <p className='text-md text-gray italic'>Your Catering Expert</p>
        </div>
      </div>

      {/* Card Body */}
      <div>
        <p className="text-lg text-black font-bold">Thanks for your inquiry!</p>
        <p className="text-lg text-black font-light">
          I'm looking at a few options for you, and will reach out soon with some curated suggestions. Chat soon!
        </p>
        {agentCalendlyLinks[experience_manager.email] && (
          <a 
            className="btn btn-blue px-4 py-1 rounded-full mt-4"
            href={agentCalendlyLinks[experience_manager.email]}
            target='_blank'
          >
            Book a call
          </a>
        )}
      </div>
    </div>
  )
}
